import { connect } from "react-redux";
import styled from "styled-components";
import { ArrowLeft } from "@phosphor-icons/react";

import ProfileDetails from './Shared/ProfileDetails';
import ProfileList from "./Profile/ProfileList";

import { clearSelectedProfile } from "../store/actions";

const ProfileInterests = (props) => {

  const backToInterestedProfiles = () => {
    props.clearSelectedProfile();
  }

  return (
    <Container>
      { (props.profiles && !props.selectedProfile) &&
        <Content>
          <ProfileList></ProfileList>
        </Content>
      }
      {
        props.selectedProfile &&
        <Content>
          <Back type="button" onClick={backToInterestedProfiles}><ArrowLeft size={18} weight="bold" /> Back to Interested Profiles</Back>
          <ProfileDetails props={ { profile: props.selectedProfile } }></ProfileDetails>
        </Content>
      }
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Back = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 18px;
  border-radius: var(--radius-pill);
  border: 1.5px solid var(--border-strong);
  background: transparent;
  color: var(--text);
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.3s var(--ease-out);

  &:hover {
    border-color: var(--text);
    transform: translateX(-2px);
  }
`;

const mapDipatchToProps = (dispatch) => ({
  clearSelectedProfile: () => dispatch(clearSelectedProfile()),
});

const mapStateToProps = (state) => {
  return {
    profile: state.profileState.profile,
    profiles: state.profileState.searchResults,
    selectedProfile: state.profileState.selectedProfile,
    user: state.userState.user,
  };
};

export default connect(mapStateToProps, mapDipatchToProps)(ProfileInterests);
